var map = {
	"./BUAP_logo.jpg": "d165",
	"./Centli_logo.jpg": "a296",
	"./Cinvestav_logo.jpg": "dffe",
	"./Colpos_logo.jpg": "edcc",
	"./Conacyt_logo.jpg": "ed74",
	"./InstitutodeGeografia_logo.jpg": "3bab",
	"./LNViviendayCS_logo.jpg": "d8ec",
	"./Screen Shot 2021-12-07 at 13.54.19.png": "dcab",
	"./UAEM_logo.jpg": "6f77",
	"./UAGro_logo.jpg": "81bd",
	"./UAM_logo.jpg": "7865",
	"./UNAM_FEconomia_logo.jpg": "274c",
	"./UNAM_logo.jpg": "2adc",
	"./UdeG_logo.jpg": "48ce",
	"./buap.jpg": "502a",
	"./centli.jpg": "c500",
	"./cinvestav.jpg": "1cd0",
	"./colpos.jpg": "c3db",
	"./conacyt.jpg": "7dbe",
	"./conacyt.png": "1910",
	"./conagua.jpg": "1c3c",
	"./conagua_400x400.jpg": "e0e7b",
	"./ig.jpg": "2022",
	"./lnvcs.jpg": "be0a",
	"./malc.jpg": "f99e",
	"./uaem.jpg": "7a8b",
	"./uagro.jpg": "c009",
	"./uam.jpg": "3c49",
	"./udg.jpg": "7c4b",
	"./unam.jpg": "6de5",
	"./unam_fe.jpg": "682d",
	"./ypel.jpg": "52f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6452";